// extracted by mini-css-extract-plugin
export var badge = "_su-4";
export var selected = "_su-1";
export var selectedOverlay = "_su-5";
export var thumbnailButton = "_su-0";
export var thumbnailFallback = "_su-3";
export var thumbnailImage = "_su-2";